import { Router } from '@solidjs/router';
import { MarketplaceSelectorPage } from './MarketplaceSelectorPage';
import { MarketplacePage } from './MarketplacePage';
export const RoutePaths = {
    default: "/",
    marketplace: "/marketplace/:marketplaceId",
    buildMarketplaceRoute: (marketplaceId) => `/marketplace/${marketplaceId}`,
    project: "/marketplace/:marketplaceId/project/:projectId",
    buildProjectRoute: (marketplaceId, projectId) => `/marketplace/${marketplaceId}/project/${projectId}`
};
const Routes = [
    {
        path: RoutePaths.default,
        component: MarketplaceSelectorPage
    },
    {
        path: RoutePaths.marketplace,
        component: MarketplacePage
    },
    {
        path: RoutePaths.project,
        component: MarketplacePage
    },
    {
        path: "*unmatched",
        component: MarketplaceSelectorPage
    }
];
export function MarketplacesAppRouter(props) {
    return (<Router url={props.url}>{Routes}</Router>);
}
